<script lang="ts" setup>
import AdvantagesSection from '~/components/sections/AdvantagesSection.vue'
import ConditionsSection from '~/components/sections/ConditionsSection.vue'
import PartnerMainSection from '~/components/sections/PartnerMainSection.vue'
import PartnerSection from '~/components/sections/PartnerSection.vue'
import PrivilegesSection from '~/components/sections/PrivilegesSection.vue'
import ProgramsSection from '~/components/sections/ProgramsSection.vue'
import SpecialistsSection from '~/components/sections/SpecialistsSection.vue'
import StepsSection from '~/components/sections/StepsSection.vue'
import Page from '~/enums/page'

definePageMeta({ layout: false })

const title = 'Программа лояльности для специалистов'

useHead({
  title: `${title} — iTAB`,
  meta: [{
    name: 'description',
    content: 'Программа лояльности для специалистов. Станьте партнёром iTAB, крупнейшего маркетплейса добавок и товаров для здоровья, и зарабатывайте вместе с нами.'
  }]
})
</script>

<template>
  <NuxtLayout name="partner">
    <section>
      <div class="container">
        <PartnerMainSection />

        <ProgramsSection />

        <ConditionsSection />

        <PrivilegesSection />

        <StepsSection />

        <SpecialistsSection />

        <AdvantagesSection />
      </div>
    </section>

    <PartnerSection :banner-id="2" class="mt-10" @on-button-click="navigateTo(Page.PartnerSignup)" />
  </NuxtLayout>
</template>

<style>
html, body {
  background-color: #F1F1F1 !important;
}
</style>
